// temporary file

import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const ACCIDENT_DETAIL_BODY_PATH = 'accident-details-body';
export const ACCIDENT_DETAIL_PROPERTY_PATH = 'accident-details-property';
export const ACCIDENT_DETAIL_INITIAL_PATH = 'accident-details-initial';
export const INSURANCE_INFORMATION_PATH = 'insurance-information';

export const PARTICIPANTS_INCIDENT_LINKS = {
  entry_tabs: (id: string) => `/${ADJUSTER_REPORT_BASE_PATH}/${id}`,
  list: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/incident-participants`,
  accident_body: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ACCIDENT_DETAIL_BODY_PATH}`,
  accident_property: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ACCIDENT_DETAIL_PROPERTY_PATH}`,
  accident_initial: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ACCIDENT_DETAIL_INITIAL_PATH}`,
  insurance_information: (id: string) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${INSURANCE_INFORMATION_PATH}`,
};
